export default __webpack_public_path__ + "static/media/hockey-canada.6a8262b7.svg";